/*------------------------------------*\
    LAZY LOAD
\*------------------------------------*/
class LazyLoad {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('[data-lazy-load-trigger]');
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            let nextThreeHiddenItems = [...self.elem.querySelectorAll('[data-card-group-item]:not([class*="show"])')].slice(0,3);

            let index = 1;
            let delayBase = 60;
            let delay = 200;

            [...nextThreeHiddenItems].map(item => {
                delay = delay + delayBase * index;
                index = index + 1;

                item.style.transitionDelay = delay + 'ms';
                item.classList.add('show');

            });

            if (self.elem.querySelectorAll('[data-card-group-item]:not([class*="show"])').length === 0) {
                self.trigger.remove();
            }
        });
    }
}

export default LazyLoad;
